<h1 class="textS+" style="text-align: center; height: 10%; margin-top: 5%" mat-dialog-title>
  {{this.localiser.get("users.sureToReset1")}}: <u>{{this.data.usuario.nombre}} {{this.data.usuario.apellidos}}</u>
  <br>
  {{this.localiser.get("users.sureToReset2")}}: <u>{{this.data.usuario.email}}</u>
</h1>

<div mat-dialog-actions style="margin-top: 10%">
  <div class="col" style="text-align: center">
    <button class="customButtonColor textS" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
  </div>

  <div class="col" style="text-align: center">
    <button class="customButtonColor textS" mat-button (click)="resetPassword()">{{this.localiser.get("button.reset")}}</button>
  </div>
</div>
